import React, { useCallback } from "react";
import "features/messages/src/styles/TeamChannelList/index.scss";

import clsx from "clsx";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import styled from "styled-components";
import { useWorkspaceController } from "../../context/WorkspaceController";

const StyledPlusOutlined = styled(PlusOutlined)`
  color: var(--sidebar-text-muted);
`;
function ChannelList(props) {
  const { children, error = false, loading, type } = props;

  const { displayWorkspace } = useWorkspaceController();

  const handleAddChannelClick = useCallback(() => {
    displayWorkspace(`Admin-Admin-Channel-Create__${type}`);
  }, [type, displayWorkspace]);

  if (error) {
    return type === "team" ? (
      <div className="team-channel-list">
        <p className="team-channel-list__message">
          Connection error, please wait a moment and try again.
        </p>
      </div>
    ) : null;
  }

  if (loading) {
    return (
      <div className="team-channel-list">
        <p className="team-channel-list__message loading">
          {type === "team" ? "Channels" : "Messages"} loading....
        </p>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        "team-channel-list",
        `team-channel-list--${type === "team" ? "group" : "dm"}`,
      )}
    >
      <div className="team-channel-list__header">
        <p className="team-channel-list__header__title">
          {type === "team" ? "Channels" : "Direct Messages"}
        </p>
        <Button type="link" onClick={handleAddChannelClick} icon={<StyledPlusOutlined />} />
      </div>
      {children}
    </div>
  );
}

export default React.memo(ChannelList);
